module.exports = {
          srcSet: __webpack_public_path__ + "f05c6d36b82df219de7687dbf068d116-1576.png"+" 1576w",
          images:[ {path: __webpack_public_path__ + "f05c6d36b82df219de7687dbf068d116-1576.png",width: 1576,height: 225}],
          src: __webpack_public_path__ + "f05c6d36b82df219de7687dbf068d116-1576.png",
          toString:function(){return __webpack_public_path__ + "f05c6d36b82df219de7687dbf068d116-1576.png"},
          
          width: 1576,
          height: 225
        }